import styled from 'styled-components';

export default styled.div`
  position: fixed;
  top: 30px;
  font-size: 30px;
  font-weight: bold;
  z-index: 2;
`;
